import { FC } from 'react';
import styles from "./MobileStudio.module.css";
import Channels from '../../../../components/Stream/Channels';
import StreamPreview from '../../../../components/StreamPreview/StreamPreview';
import Tabs from '../../../../components/Tabs';
import FunctionalButtons from '../../FunctionalButtons';
import Chat from '../../../../components/Stream/Chat';
import MobileStudioContent from './MobileStudioContent/MobileStudioContent';
import { User, UserStudio } from '../../../../features/api/apiSlice';
import { useNavigate } from 'react-router-dom';
import { getStreamOrientation } from '../../../../utils/streamOrientation';

interface MobileStudioProps {
  studio: UserStudio | undefined;
  setIsShowSettingsPopup: (show: boolean) => void;
  channelsProps: any;
  studioBroadcastId?: number | undefined;
  isLoadingTemplates: boolean;
  templatesError: any;
  studioStatus: string;
  user?: User;
}

const MobileStudio: FC<MobileStudioProps> = ({
  studio,
  studioStatus,
  setIsShowSettingsPopup,
  channelsProps,
  studioBroadcastId,
  isLoadingTemplates,
  templatesError,
  user
}) => {
  const navigate = useNavigate();
  const { getPlayerWrapperClasses, getPlayerClasses } = getStreamOrientation(studio);

  const checkStudioTariff = (title: string): boolean => {
    const requiresStudioTariff = title === "Чат" || title === "Сцены";

    if (requiresStudioTariff && !user?.tariff?.studio) {
      navigate('/tariffs');
      return false;
    }

    return true;
  };

  return (
    <Tabs
      onTabChange={checkStudioTariff}
      items={[
        {
          title: "Эфир",
          component:
            <>
              <div className={getPlayerWrapperClasses(styles["mobile-studio__player-container"], { isMobile: true })}>
                <StreamPreview
                  currentTemplate={studio?.current_scene.current_template}
                  background={studio?.current_scene.background}
                  logo={studio?.current_scene.logo}
                  className={getPlayerClasses(styles["mobile-studio__player"], { isMobile: true })}
                />
                <FunctionalButtons
                  onSettings={() => setIsShowSettingsPopup(true)}
                  studioStatus={studioStatus}
                />
              </div>
            </>
        },
        {
          title: "Каналы",
          component:
            <div className={styles["mobile-studio__content-channel"]}>
              <Channels
                {...channelsProps}
                isStudio={true}
                studioBroadcastId={studioBroadcastId}
                channels={studio?.broadcast.restream_templates}
                studio={studio}
              />
            </div>
        },
        {
          title: "Чат",
          component:
            <div className={styles["mobile-studio__content-chat"]}>
              <Chat studioBroadcastId={studioBroadcastId} studioTemplates={studio} />
            </div>
        },
        {
          title: "Сцены",
          component:
            <div className={styles["mobile-studio__content-wrapper"]}>
              <MobileStudioContent
                backgrounds={studio?.backgrounds || []}
                logos={studio?.logos}
                studio={studio}
                isLoadingTemplates={isLoadingTemplates}
                templatesError={templatesError}
                studioTemplates={studio?.studio_templates || []}
              />
            </div>
        }
      ]}
    />
  );
};

export default MobileStudio;